import { RACE } from './race';
import { BUMI } from './bumi';
import { GENDER } from './gender';
import { MARITAL_STATUS } from './maritalStatus';

const getBDFOptions = (data) => {
  if (data.length > 0) {
    return data.map((v, idx) => ({
      id: '',
      projectBookingCustomFieldID: '',
      title: v.text,
      value: v.value,
      isDeleted: false,
      isEditing: false,
      dataValue: '',
      position: idx + 1,
    }));
  }
  return null;
};
const extraPurchaserCustomFieldList = [
  {
    id: '',
    type: 'input',
    name: 'jobTitle',
    label: 'Occupation',
  },
  {
    id: '',
    type: 'input',
    name: 'monthlyIncome',
    label: 'Monthly Income',
  },
  {
    id: '',
    type: 'dropdown',
    name: 'nationality',
    label: 'Nationality',
  },
  {
    id: '',
    type: 'input',
    name: 'birthdate',
    label: 'Date of Birth',
  },
  {
    id: '',
    type: 'dropdown',
    name: 'gender',
    label: 'Gender',
    projectBookingCustomFieldOptions: getBDFOptions(GENDER),
  },
  {
    id: '',
    type: 'dropdown',
    name: 'race',
    label: 'Race',
    projectBookingCustomFieldOptions: getBDFOptions(RACE),
  },
  {
    id: '',
    type: 'dropdown',
    name: 'bumi',
    label: 'Bumi Status',
    projectBookingCustomFieldOptions: getBDFOptions(BUMI),
  },
  {
    id: '',
    type: 'dropdown',
    name: 'maritalStatus',
    label: 'Marital Status',
    projectBookingCustomFieldOptions: getBDFOptions(MARITAL_STATUS),
  },
  {
    id: '',
    type: 'input',
    name: 'emergencyContactName',
    label: 'Name of Emergency Contact',
  },
  {
    id: '',
    type: 'input',
    name: 'emergencyContactRelation',
    label: 'Emergency Contact Relation',
  },
  {
    id: '',
    type: 'input',
    name: 'emergencyContactMobile',
    label: 'Emergency Contact Number',
  },
  {
    id: '',
    type: 'input',
    name: 'emergencyContactEmail',
    label: 'Emergency Contact Email',
  },
  {
    id: '',
    type: 'input',
    name: 'emergencyContactIdentity',
    label: 'Emergency Identity Number',
  },
  {
    id: '',
    type: 'input',
    name: 'sstRegistrationNo',
    label: 'SST Registration No.',
  },
];
export const getDefaultFieldsData = (fields = {}) => fields.map((v, idx) => ({
  ...v,
  placeholder: v.label,
  defaultValue: '',
  className: '',
  style: '',
  isEditing: false,
  isRequired: false,
  isDisabled: false,
  isDeleted: false,
  isDefault: true,
  isHidden: false,
  position: (v.name === 'email' ? extraPurchaserCustomFieldList.length : idx) + 1,
  showName: false,
  errorMessage: '', // not saved inside db only for FE usage
}));
export const EXTRA_PURCHASER_CUSTOM_FIELDS = getDefaultFieldsData(extraPurchaserCustomFieldList);
const purchaserCustomFieldList = [
  {
    id: '',
    type: 'input',
    name: 'email',
    label: 'Email',
  },
];
export const PURCHASER_CUSTOM_FIELDS = getDefaultFieldsData(purchaserCustomFieldList);
export const DEFAULT_BOOKING_FIELD_LIST =
  EXTRA_PURCHASER_CUSTOM_FIELDS.concat(PURCHASER_CUSTOM_FIELDS);



// WEBPACK FOOTER //
// ./src/constants/defaultBookingFields.js